import React, { useState, useEffect } from "react";
import {
    BrowserRouter as Router, Link, NavLink, useLocation
} from "react-router-dom";
import MenuNavbar from '../../../MenuNavbar';
import Floaticons from '../../../Floaticons';
import "../TabContentStyles.css";
import { Breadcrumbs } from "@material-ui/core";

// import CSuiteAccordian from "./C-Suite-CyberAdvisory/CSuiteAccordian";
// import CRRAccordian from "./C-Suite-CyberAdvisory/CSuiteAccordian";
// import SSAccordian from "./SecurityStrategy-Organization/SSAccordian";
// import CRCAccordian from "./CyberRisk-Compliance/CRCAccordian";

import COCyberProtection from "./COCyberProtection";
import COCyberStrategy from "./COCyberStrategy";
import COCyberResilience from "./COCyberResilience";
import COCyberPhysicalSecurity from "./COCyberPhysicalSecurity";


//import CyberPhysicalSecuritydata from '../../../Data/SecuritySpecializationAcademy/CyberPhysicalSecuritydata.json';

function CrossOfferingsTab() {
    const location = useLocation();
    const propsData = location.state ? location.state.tabID : null;
    const [displaySkill, setDisplaySkill] = useState(propsData ? propsData : 'COCyberStrategy');

    return (
        <><div className="banner-container">
            <img src="images/Banner1.png" alt="banner" className="banner-img" />
            <MenuNavbar />
        </div>
            <Floaticons />
            <div className="TabPanelWrapper">
                <div className="SSA-breadcrumbLinks">
                    <Breadcrumbs separator="/" aria-label="breadcrumb">
                        <NavLink className="menu_title" to="/SecuritySpecializationAcademyNew">
                            <img src="images/SSA/Backbutton.png" class="breadcrumbBack" />
                            Cross Offerings
                        </NavLink>
                        {displaySkill === "COCyberStrategy" ? (
                            <NavLink className="menu_title" to="/CrossOfferingsNew#COCyberStrategy">
                                Cyber Strategy
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "COCyberResilience" ? (
                            <NavLink
                                className="menu_title"
                                to="/CrossOfferingsNew#COCyberResilience"
                            >
                                Cyber Resilience
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "COCyberProtection" ? (
                            <NavLink
                                className="menu_title"
                                to="/CrossOfferingsNew#COCyberProtection"
                            >
                                Cyber Physical Security
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "COCyberPhysicalSecurity" ? (
                            <NavLink
                                className="menu_title"
                                to="/CrossOfferingsNew#COCyberPhysicalSecurity"
                            >
                                Cyber Physical Security
                            </NavLink>
                        ) : (
                            ""
                        )}

                    </Breadcrumbs>
                </div>
                <div className="tabNavMenu">
                    <a
                        className={
                            displaySkill === "COCyberStrategy" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => setDisplaySkill("COCyberStrategy")}
                        href="#COCyberStrategy"
                    >
                        <span>Cyber Strategy</span>
                    </a>
                    <a
                        className={
                            displaySkill === "COCyberResilience" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("COCyberResilience");
                        }}
                        href="#COCyberResilience"
                    >
                        <span>Cyber Resilience</span>
                    </a>
                    <a
                        className={
                            displaySkill === "COCyberProtection" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("COCyberProtection");
                        }}
                        href="#COCyberProtection"
                    >
                        <span>Cyber Protection</span>
                    </a>
                    <a
                        className={
                            displaySkill === "COCyberPhysicalSecurity" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("COCyberPhysicalSecurity");
                        }}
                        href="#COCyberPhysicalSecurity"
                    >
                        <span>Cyber Physical Security</span>
                    </a>

                </div>
                <div className="TabPanel-Wrap">
                    {displaySkill === "COCyberStrategy" ? (
                        <COCyberStrategy />
                    ) : (
                        ""
                    )}
                    {displaySkill === "COCyberResilience" ? (
                        <COCyberResilience />
                    ) : (
                        ""
                    )}
                    {displaySkill === "COCyberProtection" ? (

                        <COCyberProtection />
                    ) : (
                        ""
                    )}
                    {displaySkill === "COCyberPhysicalSecurity" ? (
                        <COCyberPhysicalSecurity />
                    ) : (
                        ""
                    )}

                </div>
            </div>
        </>
    );
}

export default CrossOfferingsTab;